export default "__VITE_ASSET__DpP5GjOF__"